import React from "react";
import { Box, Typography } from "@mui/material";
import FirstLineContainer from "components/common/FirstLineContainer";

const TopPanelComponent = ({ pageType, ref, children }) => {
  return (
    <Box>
      <FirstLineContainer ref={ref}>
        <Typography variant="h6" sx={{ textAlign: "left", flex: 1 }}>
          <Box component="span" fontWeight="fontWeightBold">
            {pageType}
          </Box>
        </Typography>
      </FirstLineContainer>
      {children}
    </Box>
  );
};

export default TopPanelComponent;
